import React from "react";
import PurchaseAccountList from "../Common/PurchaseAccountList";

const StorePurchaseAccountsComp = () => (
  <PurchaseAccountList role="STORE" title="حساب خرید فروشگاه" />
);

export default StorePurchaseAccountsComp;
